module.exports = __webpack_public_path__ + "static/media/gallery-bg.8ef7bc0f.png";